import { Component, effect, inject } from '@angular/core';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { TranslationService } from 'src/app/common/services/translation.service';
@Component({
  selector: 'taly-features',
  templateUrl: './taly-features.component.html',
  styleUrls: ['./taly-features.component.scss']
})
export class TalyFeaturesComponent {
  transferSignal = inject(SharedSignalsService);
  textDirection: string;
  contentItems:any = [];

  constructor(public translationService: TranslationService, private storageService: LocalStorageService) { 
    effect(() => { 
      this.textDirection = this.transferSignal.textDirection();   
      setTimeout(() => {
        this.setDataItem();
      }, 10);
    });
  }

  ngOnInit(): void {
    
  }
  
  setDataItem(){
    this.contentItems = [
      {
        title : this.translationService.getLabelValue('HOME_PAGE.TITLE_1'),
        description:this.translationService.getLabelValue('HOME_PAGE.DESC_1'),
        imgUrl:"assets/images/icon-3.svg"
      },
      {
        title:this.translationService.getLabelValue('HOME_PAGE.TITLE_2'),
        description:this.translationService.getLabelValue('HOME_PAGE.DESC_2'),
        imgUrl:"assets/images/icon-2.svg"
      },
      {
        title:this.translationService.getLabelValue('HOME_PAGE.TITLE_3'),
        description:this.translationService.getLabelValue('HOME_PAGE.DESC_3'),
        imgUrl:"assets/images/icon-1.svg"
      },
    ]      
  }
}
